import { ArrowLeft, Download, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import { Notice, PageHeader } from "../components/ui";
import { useDossier } from "../dossier";
import { w } from "../i18n";

const TEMPLATE_URL = "/templates/sfcr-sfpj-report.html";

/** Supplied SFPJ reference, isolated from the workspace and its dossier data. */
export function ReportTemplatePage() {
  const { dossier } = useDossier();

  return <section className="ws-template-page">
    <PageHeader eyebrow="SFCR · SFPJ 2025" title={w("report.referenceTemplate")}
      lead={w("report.referenceTemplateLead")}
      actions={<div className="ws-row">
        <Link className="ws-btn" to={`/dossiers/${dossier.id}/report`}>
          <ArrowLeft size={16} aria-hidden="true" />{w("report.backToReport")}</Link>
        <a className="ws-btn" href={TEMPLATE_URL} target="_blank" rel="noopener noreferrer">
          <ExternalLink size={16} aria-hidden="true" />{w("report.openTemplate")}</a>
        <a className="ws-btn primary" href={TEMPLATE_URL} download="SFCR_SFPJ_Report_Template.html">
          <Download size={16} aria-hidden="true" />{w("report.downloadTemplate")}</a>
      </div>} />
    <Notice tone="neutral">{w("report.referenceTemplateNote")}</Notice>
    <div className="ws-card ws-report-template">
      <iframe src={TEMPLATE_URL} title={w("report.referenceTemplate")}
        sandbox="allow-scripts allow-downloads allow-modals" />
    </div>
  </section>;
}
